import { useMemo } from 'react'
import { Enums } from '../interfaces'

export const useTasksMaps = (enums: Enums) => {
  // Создаем Map для быстрого поиска стадий
  const stagesMap = useMemo(() => {
    if (!enums?.stages) return new Map()
    return new Map(enums.stages.map(item => [item.value, item.label]))
  }, [enums?.stages])

  // Создаем Map для быстрого поиска типов задач
  const taskTypesMap = useMemo(() => {
    if (!enums?.task_type) return new Map()
    return new Map(enums.task_type.map(item => [item.value, item.label]))
  }, [enums?.task_type])

  return {
    stagesMap,
    taskTypesMap,
  }
}
